import React, { useEffect } from 'react';

const AccountDeletionPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="container mx-auto px-4 py-16 max-w-4xl" style={{ marginTop: '5rem' }}>
            <h1 className="text-3xl font-bold mb-6">Account Deletion</h1>
            <p className="mb-4">
                You have the right to request the deletion of your PrepAiro account at any time. To initiate this process:
            </p>
            <ol className="list-decimal list-inside mb-4">
                <li>Open the <strong>PrepAiro</strong> app.</li>
                <li>Go to <strong>Settings &gt; Profile</strong>.</li>
                <li>Tap on <strong>“Delete Account”</strong> and confirm your request.</li>
            </ol>
            <p className="mb-4">
                Upon confirmation:
            </p>
            <ul className="list-disc list-inside mb-4">
                <li>Your account will enter a <strong>30-day grace period</strong>. During the first <strong>7 days</strong>, you can revoke this request by logging back into your account.</li>
                <li>After the 7-day revocation window, the account will be scheduled for permanent deletion at the end of the 30-day period.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-8 mb-4">Data Retention and Deletion</h2>
            <ul className="list-disc list-inside mb-4">
                <li>During the <strong>30-day grace period</strong>, your data remains intact, allowing you to recover your account if desired.</li>
                <li>Post the 30-day period, all personal data associated with your account will be permanently deleted, except for information we are legally obligated to retain.</li>
            </ul>
            <p className="mb-4">
                For any questions or assistance regarding account deletion, please contact our support team at <a href="mailto:support@prepairo.ai">support@prepairo.ai</a>.
            </p>
        </div>
    );
};

export default AccountDeletionPage;